import { render, staticRenderFns } from "./text-header.vue?vue&type=template&id=c4727a68&scoped=true&"
import script from "./text-header.vue?vue&type=script&lang=js&"
export * from "./text-header.vue?vue&type=script&lang=js&"
import style0 from "./text-header.vue?vue&type=style&index=0&id=c4727a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4727a68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4727a68')) {
      api.createRecord('c4727a68', component.options)
    } else {
      api.reload('c4727a68', component.options)
    }
    module.hot.accept("./text-header.vue?vue&type=template&id=c4727a68&scoped=true&", function () {
      api.rerender('c4727a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-header.vue"
export default component.exports